import { TriangleAlert, X } from 'lucide-react';

/**
 * Dismissible amber safety reminder shown at the top of the chat area.
 *
 * The copy is fixed product copy - do not paraphrase it.
 */
const REMINDER =
  'Reminder: Do not share delivery information with anyone in chat unless you have received a real order. All payments and chats must go through Z2Market. Be cautious of anyone claiming to be Z2Market staff outside the platform.';

export default function SafetyBanner({ onDismiss }) {
  return (
    <div
      role="status"
      className="animate-z2-drop flex items-start gap-2.5 rounded-2xl border border-amber-300 bg-amber-50 px-3 py-2.5 sm:gap-3 sm:px-4 sm:py-3 dark:border-amber-500/25 dark:bg-amber-500/10"
    >
      <span className="mt-px grid h-6 w-6 shrink-0 place-items-center rounded-lg bg-amber-400/30 text-amber-700 sm:h-7 sm:w-7 dark:text-amber-300">
        <TriangleAlert size={15} />
      </span>

      <p className="flex-1 text-[12px] leading-relaxed text-amber-900 sm:text-[12.5px] dark:text-amber-100/90">
        {REMINDER}
      </p>

      <button
        type="button"
        onClick={onDismiss}
        aria-label="Dismiss safety reminder"
        className="-mt-0.5 -mr-1 grid h-7 w-7 shrink-0 place-items-center rounded-lg text-amber-700/80 transition hover:bg-amber-400/25 hover:text-amber-900 dark:text-amber-200/80 dark:hover:text-amber-100"
      >
        <X size={15} />
      </button>
    </div>
  );
}
